export const PHONG_NHA_STOREFRONT_ID = 'phong-nha'
export const PHONG_NHA_BASE_PATH = '/phong-nha'

export type StorefrontConfig = {
  id: 'antau' | typeof PHONG_NHA_STOREFRONT_ID
  basePath: '/' | typeof PHONG_NHA_BASE_PATH
  fixedStoreNo?: string
  theme: 'antau' | 'phong-nha'
}

export const ANTAU_STOREFRONT: StorefrontConfig = {
  id: 'antau',
  basePath: '/',
  theme: 'antau',
}

export const PHONG_NHA_STOREFRONT: StorefrontConfig = {
  id: PHONG_NHA_STOREFRONT_ID,
  basePath: PHONG_NHA_BASE_PATH,
  fixedStoreNo: PHONG_NHA_STOREFRONT_ID,
  theme: 'phong-nha',
}

const normalizePathname = (pathname: string) => {
  if (!pathname || pathname === '/') return '/'

  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
}

export const resolveStorefront = (
  pathname = window.location.pathname,
): StorefrontConfig => {
  const normalizedPathname = normalizePathname(pathname)
  const isPhongNha =
    normalizedPathname === PHONG_NHA_BASE_PATH ||
    normalizedPathname.startsWith(`${PHONG_NHA_BASE_PATH}/`)

  if (isPhongNha) {
    return PHONG_NHA_STOREFRONT
  }

  return ANTAU_STOREFRONT
}

export const storefrontConfig = resolveStorefront()

export const getStorefrontStorageKey = (key: string) =>
  storefrontConfig.id === 'antau' ? key : `${key}:${storefrontConfig.id}`

type StorefrontPath<Path extends `/${string}`> =
  | Path
  | (Path extends '/' ? '/phong-nha' : `/phong-nha${Path}`)

export const createStorefrontPath = <Path extends `/${string}`>(
  path: Path,
  storefront: StorefrontConfig = storefrontConfig,
): StorefrontPath<Path> => {
  if (storefront.id === 'antau') return path

  if ((path as string) === '/') {
    return PHONG_NHA_BASE_PATH as StorefrontPath<Path>
  }

  return `${PHONG_NHA_BASE_PATH}${path}` as StorefrontPath<Path>
}

export const createStorefrontUrl = (
  path: string,
  storefront: StorefrontConfig = storefrontConfig,
) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  return `${window.location.origin}${createStorefrontPath(
    normalizedPath as `/${string}`,
    storefront,
  )}`
}
